import { render, staticRenderFns } from "./VActivities.vue?vue&type=template&id=d06fe180&"
import script from "./VActivities.vue?vue&type=script&lang=js&"
export * from "./VActivities.vue?vue&type=script&lang=js&"
import style0 from "./VActivities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports